'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonColorConstants = exports.buttonHeightConstants = exports.buttonSizeConstants = exports.buttonConstants = undefined;

var _reactackleCore = require('reactackle-core');

var buttonConstants = exports.buttonConstants = {
  functionFactor: 0.15
};
var buttonSizeConstants = exports.buttonSizeConstants = {
  small: {
    lineHeight: 1,
    fontSize: _reactackleCore.fontSize['-1'],
    paddingY: 0,
    textPaddingY: _reactackleCore.baseModule,
    subtitleFontSize: _reactackleCore.fontSize['-1'],
    subtitleLineHeight: 1
  },
  normal: {
    lineHeight: 1.25,
    fontSize: _reactackleCore.fontSize[0],
    paddingY: 0,
    textPaddingY: _reactackleCore.baseModule,
    subtitleFontSize: _reactackleCore.fontSize[0],
    subtitleLineHeight: 1.25
  },
  large: {
    lineHeight: 1.15,
    fontSize: _reactackleCore.fontSize[1],
    paddingY: 0,
    textPaddingY: _reactackleCore.oneAndHalfBaseModule,
    subtitleFontSize: _reactackleCore.fontSize[1],
    subtitleLineHeight: 1.15
  }
};
var buttonHeightConstants = exports.buttonHeightConstants = {
  buttonSmallMinHeight: function buttonSmallMinHeight(base) {
    return buttonSizeConstants.small.lineHeight * buttonSizeConstants.small.fontSize + (buttonSizeConstants.small.paddingY + buttonSizeConstants.small.textPaddingY(base)) * 2;
  },
  buttonNormalMinHeight: function buttonNormalMinHeight(base) {
    return buttonSizeConstants.normal.lineHeight * buttonSizeConstants.normal.fontSize + (buttonSizeConstants.normal.paddingY + buttonSizeConstants.normal.textPaddingY(base)) * 2;
  },
  buttonLargeMinHeight: function buttonLargeMinHeight(base) {
    return buttonSizeConstants.large.lineHeight * buttonSizeConstants.large.fontSize + (buttonSizeConstants.large.paddingY + buttonSizeConstants.large.textPaddingY(base)) * 2;
  }
};
var buttonColorConstants = exports.buttonColorConstants = {
  primary: {
    backgroundColor: _reactackleCore.colorMain,
    fontColor: function fontColor(_ref) {
      var color = _ref.color;
      return color.mainFgTextColor;
    }
  },
  secondary: {
    backgroundColor: _reactackleCore.colorSecondary,
    fontColor: function fontColor(_ref2) {
      var color = _ref2.color;
      return color.secondaryFgTextColor;
    }
  },
  alert: {
    backgroundColor: function backgroundColor(_ref3) {
      var color = _ref3.color;
      return color.alert;
    },
    fontColor: function fontColor(_ref4) {
      var color = _ref4.color;
      return color.alertFgTextColor;
    }
  },
  success: {
    backgroundColor: function backgroundColor(_ref5) {
      var color = _ref5.color;
      return color.success;
    },
    fontColor: function fontColor(_ref6) {
      var color = _ref6.color;
      return color.successFgTextColor;
    }
  },
  warning: {
    backgroundColor: function backgroundColor(_ref7) {
      var color = _ref7.color;
      return color.warning;
    },
    fontColor: function fontColor(_ref8) {
      var color = _ref8.color;
      return color.warningFgTextColor;
    }
  },
  info: {
    backgroundColor: function backgroundColor(_ref9) {
      var color = _ref9.color;
      return color.info;
    },
    fontColor: function fontColor(_ref10) {
      var color = _ref10.color;
      return color.infoFgTextColor;
    }
  },
  link: {
    backgroundColor: _reactackleCore.colorTransparent,
    fontColor: function fontColor(_ref11) {
      var colorAnchor = _ref11.colorAnchor;
      return colorAnchor;
    }
  }
};